import { render } from "./CreditoSimpleOS.vue?vue&type=template&id=09975d6c"
import script from "./CreditoSimpleOS.vue?vue&type=script&lang=js"
export * from "./CreditoSimpleOS.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__